import React from 'react';

function AddNewQuestionIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
            <rect width="24" height="24" transform="translate(0.833313)" fill="white" fill-opacity="0.01" />
            <path
                d="M16.8353 3H5.82831C5.29921 3 4.79177 3.21019 4.41763 3.58432C4.0435 3.95846 3.83331 4.46589 3.83331 4.995V19.005C3.83331 20.107 4.72631 21 5.82831 21H19.8383C20.3674 21 20.8749 20.7898 21.249 20.4157C21.6231 20.0415 21.8333 19.5341 21.8333 19.005V7.998V11H19.8333V19H5.83331V5H13.8333V3H16.8353Z"
                fill="#00214D"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M19.8333 5V3.99C19.8307 3.72652 19.7242 3.47473 19.5369 3.28935C19.3497 3.10397 19.0968 2.99999 18.8333 3C18.2773 3 17.8333 3.444 17.8333 3.99V5H16.8333C16.5681 5 16.3137 5.10536 16.1262 5.29289C15.9387 5.48043 15.8333 5.73478 15.8333 6C15.8333 6.26522 15.9387 6.51957 16.1262 6.70711C16.3137 6.89464 16.5681 7 16.8333 7H17.8333V8.01C17.8359 8.27348 17.9425 8.52527 18.1297 8.71065C18.317 8.89603 18.5698 9.00001 18.8333 9C19.3893 9 19.8333 8.556 19.8333 8.01V7H20.8333C21.0985 7 21.3529 6.89464 21.5404 6.70711C21.728 6.51957 21.8333 6.26522 21.8333 6C21.8333 5.73478 21.728 5.48043 21.5404 5.29289C21.3529 5.10536 21.0985 5 20.8333 5H19.8333Z"
                fill="#00214D"
            />
        </svg>
    );
}

export default AddNewQuestionIcon;
